import { X, Share } from 'lucide-react';

export default function IosHintModal({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-[120] flex items-end sm:items-center justify-center bg-black/50 p-4"
      onClick={onClose}
      data-testid="install-ios-hint"
    >
      <div className="bg-white rounded-2xl p-5 max-w-sm w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-[15px] font-bold text-zinc-900">Zainstaluj ApisAI</h3>
          <button onClick={onClose} aria-label="Zamknij"><X className="w-4 h-4 text-zinc-400" /></button>
        </div>
        <p className="text-[13px] text-zinc-600 leading-relaxed">
          Na iPhone / iPad: dotknij <Share className="inline w-4 h-4 -mt-0.5 text-[var(--apisai-primary)]" />{' '}
          <strong>Udostępnij</strong> na dole ekranu, a następnie wybierz{' '}
          <strong>„Dodaj do ekranu początkowego"</strong>. ApisAI pojawi się jak zwykła aplikacja.
        </p>
      </div>
    </div>
  );
}
